import * as yup from "yup";

export interface AccountDeletionFormValues {
  fullName: string;
  email: string;
  accountType: "customer" | "employee";
  reason: string;
  confirm: boolean;
}

export const accountDeletionSchema: yup.SchemaOf<AccountDeletionFormValues> =
  yup.object({
    fullName: yup
      .string()
      .trim()
      .required("Please enter your full name")
      .max(120, "Full name must be 120 characters or fewer"),
    email: yup
      .string()
      .trim()
      .required("Please enter your registered email")
      .email("Enter a valid email address")
      .max(255, "Email must be 255 characters or fewer"),
    accountType: yup
      .mixed<"customer" | "employee">()
      .oneOf(["customer", "employee"], "Choose Customer or Employee")
      .required("Choose Customer or Employee"),
    reason: yup
      .string()
      .trim()
      .max(2000, "Reason must be 2000 characters or fewer")
      .default(""),
    confirm: yup
      .boolean()
      .oneOf([true], "You must confirm to submit")
      .required(),
  });

export const accountDeletionDefaults: AccountDeletionFormValues = {
  fullName: "",
  email: "",
  accountType: "customer",
  reason: "",
  confirm: false,
};
